// extracted by mini-css-extract-plugin
module.exports = {"ProductOptionSelectorUIWrapper":"ProductOptionSelectorUI_ProductOptionSelectorUIWrapper__nCgvA"};